import React from "react"

import WhatsappIcon from "../../assets/icons/whatsapp-icon.svg"
import PhoneIcon from "../../assets/icons/phone-icon.svg"
import classes from "./footer.module.scss"

const Footer = () => {
  return (
    <footer className={classes.Footer} id="footer">
      <div className={classes.Contact}>
        <WhatsappIcon className={classes.Icon} />
        <div className={classes.Info}>
          <h3>Whatsapp</h3>
          <p>3756 - 491471</p>
        </div>
      </div>
      <div className={classes.Contact}>
        <PhoneIcon className={classes.Icon} />
        <div className={classes.Info}>
          <h3>Teléfono</h3>
          <p>3756 - 481451</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
